// Copyright ©️ 2026 eVolve MEP, LLC

import { useActionState } from 'react';

/**
 * Returns a `key` for a component and a function that changes that key, which makes React remount the component.
 * @param prefix Goes at the start of the key so it doesn't match keys of the component's siblings.
 */
export const useRemountKey = (prefix: string) => {
  const [version, remount] = useActionState((prevVersion: number) => prevVersion + 1, 0);
  return [`${prefix}-${version}`, remount] as const;
};
